/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { titleIdGet } from '../fn/title/title-id-get';
import { TitleIdGet$Params } from '../fn/title/title-id-get';
import { TitleModel } from '../models/title-model';
import { TitleModelSearchResultModel } from '../models/title-model-search-result-model';
import { titlePost } from '../fn/title/title-post';
import { TitlePost$Params } from '../fn/title/title-post';
import { titleSearchTitlePost } from '../fn/title/title-search-title-post';
import { TitleSearchTitlePost$Params } from '../fn/title/title-search-title-post';

@Injectable({ providedIn: 'root' })
export class MDITitleService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `titleSearchTitlePost()` */
  static readonly TitleSearchTitlePostPath = '/Title/SearchTitle';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `titleSearchTitlePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  titleSearchTitlePost$Response(params?: TitleSearchTitlePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<TitleModelSearchResultModel>> {
    return titleSearchTitlePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `titleSearchTitlePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  titleSearchTitlePost(params?: TitleSearchTitlePost$Params, context?: HttpContext): Observable<TitleModelSearchResultModel> {
    return this.titleSearchTitlePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<TitleModelSearchResultModel>): TitleModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `titleIdGet()` */
  static readonly TitleIdGetPath = '/Title/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `titleIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  titleIdGet$Response(params: TitleIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<TitleModel>> {
    return titleIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `titleIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  titleIdGet(params: TitleIdGet$Params, context?: HttpContext): Observable<TitleModel> {
    return this.titleIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<TitleModel>): TitleModel => r.body)
    );
  }

  /** Path part for operation `titlePost()` */
  static readonly TitlePostPath = '/Title';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `titlePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  titlePost$Response(params?: TitlePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return titlePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `titlePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  titlePost(params?: TitlePost$Params, context?: HttpContext): Observable<string> {
    return this.titlePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
